import { segment } from '@actions/analytics';
import { PLANNER_VIDEO_CARD_VIEWED } from '@constants/segment';
import GoalResults from '@cont/SuccessStory/GoalResults';
import LearnerReviews from '@cont/SuccessStory/LearnerReviews';
import styled from '@emotion/styled';
import useGoalEventProps from '@hooks/useGoalEventProps';
import { mediaQuery, Spacings } from '@styles/index';
import isEmptyObject from '@utils/isEmptyObject';
import React, { useEffect } from 'react';
import Typography from 'aquilla/core/atoms/Typography';
import { useRouter } from 'next/router';
import YouTube from 'aquilla/core/organisms/YouTubeEmbed';
import AchieversCard from './AchieversCard';

const SuccessStoryContainer = styled.div`
  width: var(--layout-width);
  margin: ${Spacings.SPACING_12B} auto ${Spacings.SPACING_12B};

  ${mediaQuery.uptoTablet} {
    width: 100%;
    padding: 0 ${Spacings.SPACING_8B};
    margin: ${Spacings.SPACING_5B} auto ${Spacings.SPACING_9B};
  }

  ${mediaQuery.uptoMobile} {
    width: 100%;
    margin: ${Spacings.SPACING_5B} auto ${Spacings.SPACING_9B};
    padding: unset;
  }
`;

const SuccessStoryHeaderDivider = styled.div`
  width: 100%;
  height: 0px;
  padding-left: ${Spacings.SPACING_4B};
  padding-right: ${Spacings.SPACING_4B};
  margin-top: ${Spacings.SPACING_6B};
  background: var(--color-i-divider);

  ${mediaQuery.uptoMobile} {
    display: none;
  }
`;

const StyledNewAchieversWrapper = styled.div`
  [class*='SecWrapper'] {
    margin-top: 0px;
    height: auto;
    padding: ${Spacings.SPACING_11B} 0;
  }
  [class*='CarouselSection'] {
    margin: 0;
  }
  [class*='HeadingSection'] {
    display: none;
  }
`;

const SuccessStoryHeroTitleContainer = styled.div`
  display: flex;
  justify-content: center;

  ${mediaQuery.uptoMobile} {
    justify-content: flex-start;
    /* width: 70%; */
  }
`;

const SuccessStoryHeroTitle = styled(Typography)`
  text-align: center;
  max-width: 708px;

  ${mediaQuery.uptoTablet} {
    font-size: ${Spacings.SPACING_8B};
    line-height: ${Spacings.SPACING_10B};
  }
  ${mediaQuery.uptoMobile} {
    padding: 0 ${Spacings.SPACING_4B};
    justify-content: flex-start;
    text-align: start;
  }
`;

const SuccessStoryHeroDescription = styled(Typography)`
  margin-top: ${Spacings.SPACING_4B};
  text-align: center;

  ${mediaQuery.uptoMobile} {
    text-align: start;
    margin: ${Spacings.SPACING_3B} 0 ${Spacings.SPACING_6B};
    padding: 0 ${Spacings.SPACING_4B};
    width: 70%;
  }
`;

const SuccessStoryHeroMediaContainer = styled.div`
  margin: ${Spacings.SPACING_12B} 0;

  ${mediaQuery.uptoMobile} {
    margin: ${Spacings.SPACING_6B} ${Spacings.SPACING_4B} 0;
  }
`;

const TITLE = 'Unacademy is the perfect place for your preparation';

const NewSuccessStory = ({ cmsData, reviewsBlock, achievementBlock }) => {
  const gloablaEventProps = useGoalEventProps({});
  const {
    query: { goalUID }
  } = useRouter();

  useEffect(() => {
    if (cmsData?.heroBanner?.videoUrl)
      segment.track(PLANNER_VIDEO_CARD_VIEWED, { ...gloablaEventProps });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <>
      <SuccessStoryContainer>
        <SuccessStoryHeroTitleContainer>
          <SuccessStoryHeroTitle variant="h1">{TITLE}</SuccessStoryHeroTitle>
        </SuccessStoryHeroTitleContainer>
        <SuccessStoryHeroDescription variant="h5">
          {'Over '}
          <Typography as="span" variant="h5" color="#08BD80">
            10 crore
          </Typography>
          {' learners trust us for their preparation'}
        </SuccessStoryHeroDescription>
        <SuccessStoryHeaderDivider />
        {!isEmptyObject(cmsData?.heroBanner) ? (
          <SuccessStoryHeroMediaContainer>
            <YouTube
              src={cmsData.heroBanner.videoUrl}
              autoplay
              muted
              controls
            />
          </SuccessStoryHeroMediaContainer>
        ) : null}
        {!isEmptyObject(cmsData?.examResult) ? (
          <GoalResults data={cmsData.examResult} />
        ) : null}
        {!isEmptyObject(achievementBlock) ? (
          <StyledNewAchieversWrapper>
            <AchieversCard block={achievementBlock} goalUID={goalUID} />
          </StyledNewAchieversWrapper>
        ) : null}
        {!isEmptyObject(reviewsBlock) ? (
          <LearnerReviews data={reviewsBlock} />
        ) : null}
      </SuccessStoryContainer>
    </>
  );
};

export default NewSuccessStory;
